import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getPaths } from '../../utils/element';
export const resellersApi = createApi({
    reducerPath: 'resellersApi',
    baseQuery: fetchBaseQuery({ baseUrl: getPaths().app_ajax_resellers }),
    endpoints: builder => ({
        getResellers: builder.query({
            query: () => '',
        }),
    }),
});
export const { useGetResellersQuery } = resellersApi;
